import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { formatDateIL } from '../../util/formatsForDate';

const UserDetails = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const res = await axios.get('dashboard/member/member_self');
                setUser(res.data);
            } catch (err) {
                console.error(err);
                setError('שגיאה בטעינת הנתונים');
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);
    return (
        <div className="p-6 bg-white shadow-md rounded-md space-y-6">
            {/* פרטים אישיים */}
            <div>
                <h2 className="text-xl font-bold border-b pb-2 mb-4 text-right">פרטים אישיים</h2>
                <div className="grid grid-cols-2 gap-4 text-right">
                    <p><span className="font-semibold text-gray-700">תאריך הרשמה:</span> {formatDateIL(user?.dateRegister)}</p>
                    <p><span className="font-semibold text-gray-700">מספר חבר:</span> {user?.number}</p>
                    <p><span className="font-semibold text-gray-700">שם פרטי:</span> {user?.firstName}</p>
                    <p><span className="font-semibold text-gray-700">שם משפחה:</span> {user?.lastName}</p>
                    <p><span className="font-semibold text-gray-700">ת.ז.:</span> {user?.idNumber}</p>
                    <p><span className="font-semibold text-gray-700">תאריך לידה:</span> {formatDateIL(user?.dateBorn)}</p>
                    <p><span className="font-semibold text-gray-700">מקום עבודה:</span> {user?.job}</p>
                </div>
            </div>

            {/* כתובת */}
            <div>
                <h2 className="text-xl font-bold border-b pb-2 mb-4 text-right">כתובת</h2>
                <div className="grid grid-cols-2 gap-4 text-right">
                    <p><span className="font-semibold text-gray-700">עיר:</span> {user?.city}</p>
                    <p><span className="font-semibold text-gray-700">רחוב:</span> {user?.street}</p>
                    <p><span className="font-semibold text-gray-700">מספר בית:</span> {user?.houseNumber}</p>
                    <p><span className="font-semibold text-gray-700">מספר דירה:</span> {user?.apartmentNumber}</p>
                </div>
            </div>

            <div>
                <h2 className="text-xl font-bold border-b pb-2 mb-4 text-right">פרטי התקשרות </h2>
                <div className="grid grid-cols-2 gap-4 text-right">
                    <p>{user?.email} <span className="font-semibold text-gray-700 ">:דוא"ל</span> </p>
                    <p><span className="font-semibold text-gray-700">טלפון ראשי:</span> {user?.mainPhone}</p>
                    <p><span className="font-semibold text-gray-700">טלפון נוסף:</span> {user?.additionalPhone}</p>
                </div>
            </div>

            <div>
                <h2 className="text-xl font-bold border-b pb-2 mb-4 text-right">אישור כשירות </h2>
                <div className="grid grid-cols-2 gap-4 text-right">
                    <p><span className="font-semibold text-gray-700">מספר נ.ש.:</span> {user?.nsnumber}</p>
                </div>
            </div>



            <div className="mt-10">
                <h2 className="text-xl font-bold text-right mb-4">קבצים מצורפים</h2>

                {/* תמונת פנים */}
                {user?.imgFacePicture && (
                    <div className="border p-4 mb-4 bg-gray-200 rounded-md text-center">
                        <p className="mb-2 font-semibold">תמונת פנים</p>
                        <img
                            src={`https://archivebureau.s3.eu-west-3.amazonaws.com/${user.imgFacePicture}`}
                            alt="תמונת פנים"
                            className="mx-auto max-w-[150px] max-h-[150px] object-contain border"
                            
                        />
                    </div>
                )}

                {/* חתימה */}
                {user?.imgSignature && (
                    <div className="border p-4 bg-gray-200 rounded-md text-center">
                        <p className="mb-2 font-semibold">חתימה</p>
                        <img
                            src={`https://archivebureau.s3.eu-west-3.amazonaws.com/${user.imgSignature}`}
                            alt="חתימה"
                            className="mx-auto max-w-[150px] max-h-[150px] object-contain border"
                        />
                    </div>
                )}
            </div>
        </div>


    );
}

export default UserDetails